module.exports = __webpack_public_path__ + "static/media/index.203b726a.cjs";